import { FunctionComponent, useEffect, useState } from 'react'

import { MdPlayArrow, MdSearch, MdCheck } from 'react-icons/md'
import { Grid } from '@material-ui/core'

import Autocomplete from 'shared/components/Autocomplete'
import Scaffold from 'shared/components/ScaffoldNew'
import Text from 'shared/components/Text'
import useDebounce from 'shared/hooks/useDebounce'
import { colors } from 'shared/styles/colors'
import { registerEvent } from 'shared/services/TrackingGAService'
import { useFrotista } from 'modules/user/hooks/useFrotista'
import { Value } from 'shared/components/ModalSelectFrotista/styles'
import { useCaminhao } from 'modules/caminhao/hooks/useCaminhao'
import Veiculo from 'modules/veiculos/domain/entities/Veiculo'
import { IListVeiculosImpl } from 'modules/veiculos/domain/usecases/ListVeiculosImpl'

type TProps = {
  listVeiculos: IListVeiculosImpl
}

const HorsePlate: FunctionComponent<TProps> = ({ listVeiculos }) => {
  const {
    veiculo,
    setVeiculo,
    handleBackButton,
    loading,
    setLoading,
    setError,
    setErrorMessage,
    handleCreateCaminhao,
    nomeCaminhao,
    tipoCaminhao,
    handleNextButton,
  } = useCaminhao()
  const { frotistaId, frotista } = useFrotista()
  const [placaInput, setPlacaInput] = useState('')
  const [veiculosList, setVeiculoList] = useState<Veiculo[]>([])
  const [loadingInput, setLoadingInput] = useState(false)

  const debouncedPlaca = useDebounce(placaInput, 1000)

  useEffect(() => {
    const init = async () => {
      if (debouncedPlaca && placaInput) {
        setLoadingInput(true)

        try {
          const response = await listVeiculos.execute({
            placa: placaInput,
            tipo: 'CAVALO',
            ativo: true,
          })
          setLoadingInput(false)

          setVeiculoList(response?.data)
        } catch (e) {
          setLoadingInput(false)
        }
      } else {
        setVeiculoList([])
      }
    }

    init()
  }, [debouncedPlaca])

  const handleplaca = (placa: string) => {
    setPlacaInput(placa)
  }

  const handleNextButtonFn = async () => {
    registerEvent({
      categoria: 'Cadastro de Caminhão',
      acao: 'Click Próximo',
      local: 'Tela/Passo de selecionar a placa do cavalo',
    })

    setLoading(true)
    try {
      if (veiculo) {
        if (tipoCaminhao?.quantidade_carretas === 0) {
          await handleCreateCaminhao(
            frotistaId,
            nomeCaminhao,
            tipoCaminhao?.id,
            veiculo?.id,
            null,
            null,
            null,
          )
        } else {
          handleNextButton()
        }
        setLoading(false)
      }
    } catch (e: unknown) {
      setLoading(false)
      if (e instanceof Error) {
        setErrorMessage(e.message)
      } else {
        setErrorMessage('Erro no cadastro de caminhão')
      }
      setError(true)
    }
  }

  return (
    <>
      <Scaffold
        onClickBackButton={handleBackButton}
        onClickNextButton={handleNextButtonFn}
        titleBackButton="Voltar"
        titleNextButton={
          tipoCaminhao?.quantidade_carretas === 0 ? 'Salvar' : 'Próximo'
        }
        isNextButtonDisabled={!veiculo}
        showFooterScaffold
        icon={tipoCaminhao?.quantidade_carretas === 0 ? MdCheck : MdPlayArrow}
        color={veiculo ? colors.green : colors.gray}
        title="Placa do cavalo"
        titleHeader="Novo caminhão"
        loading={loading}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={3}>
            <Autocomplete
              label="Qual a placa do cavalo?"
              placeholder="Por ex: Bitrem 2 eixosd"
              onChange={(_event, newValue: Veiculo) => {
                setVeiculo(newValue)
              }}
              inputValue={placaInput}
              onInputChange={(_event, newInputValue) => {
                handleplaca(newInputValue)
              }}
              options={veiculosList}
              getOptionLabel={option => (option as Veiculo).placa}
              loading={loadingInput}
              popupIcon={MdSearch}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={9} />
          {veiculo && (
            <>
              <Grid item xs={12} sm={12} md={3}>
                <Text color={colors.blue}>Placa do cavalo</Text>
                <Text color={colors.grayDark} weight="bold">
                  {veiculo?.placa}
                </Text>
              </Grid>
              <Grid item xs={12} sm={12} md={3}>
                <Text color={colors.blue}>RENAVAM</Text>
                <Text color={colors.grayDark} weight="bold">
                  {veiculo?.renavam}
                </Text>
              </Grid>
              <Grid item xs={12} sm={12} md={3}>
                <Text color={colors.blue}>Local de emissão</Text>
                <Text color={colors.grayDark} weight="bold">
                  {veiculo?.local_emissao}
                </Text>
              </Grid>
              <Grid item xs={12} sm={12} md={3} />
              <Grid item xs={12} sm={12} md={3}>
                <Text color={colors.blue}>Pais</Text>
                <Text color={colors.grayDark} weight="bold">
                  BRASIL
                </Text>
              </Grid>
              <Grid item xs={12} sm={12} md={3}>
                <Text color={colors.blue}>Padrão MERCOSUL</Text>
                <Text color={colors.grayDark} weight="bold">
                  {veiculo?.placa
                    ? (veiculo?.placa.match(/\d/g) || []).length > 3
                      ? 'INATIVO'
                      : 'ATIVO'
                    : ' '}
                </Text>
              </Grid>
              <Grid item xs={12} sm={12} md={3}>
                <Text color={colors.blue}>Chassi</Text>
                <Text color={colors.grayDark} weight="bold">
                  {veiculo?.chassi}
                </Text>
              </Grid>
              <Grid item xs={12} sm={12} md={3} />
            </>
          )}
        </Grid>
        {frotistaId && (
          <Grid container style={{ marginTop: 100 }}>
            <Grid item>CNPJ Selecionado (Caminhão):</Grid>
            <Grid item>
              <Value>{frotista?.cnpj}</Value>
            </Grid>
          </Grid>
        )}
      </Scaffold>
    </>
  )
}

export default HorsePlate
